import moment from 'moment';
import { useState } from 'react';
import { TableInput } from '../../../../../../components/common';
import DatePickerMui from '../../../../../../components/common/DatePickerMui';
import formatDate from '../../../../../../components/common/formatDate';
import { TableCompHead } from '../../../../../../components/ui';
import { createConstant } from '../../constant';
import { useQuery } from '../../../../../../hooks/UseQuery';

const style1 = {
  backgroundColor: '#4F81BD',
  color: '#fff',
  minWidth: '150px',
};
const style2 = {
  backgroundColor: '#00B050',
  color: '#fff',
};
interface IProps {
  moduleData: any;
  isView: boolean;
}

const getYearRange = (currentDate: any) => {
  if (!currentDate) return;
  const year = new Date(currentDate).getFullYear();
  return `${year} - ${year + 1}`;
};
const THead = ({ moduleData, isView }: IProps) => {
  console.log('GGGGGGGGGGGGGGGGGGG', moduleData?.date_range);
  const [render, setRender] = useState(false);
  const date = new Date(moduleData?.date_range)
    ?.getFullYear()
    .toString()
    .slice(-2);
  const yearRange = getYearRange(new Date(moduleData?.date_range));
  return (
    <thead>
      <TableCompHead
        colSpan={13 + createConstant.extracolSpan}
        rowSpan={3}
        labels={['Doc No', 'Rev', 'Dt']}
        values={['FM/XLI/MT/008', '00', 'November 2018']}
        heading={`${createConstant.theadHeader}`}
      />
      <tr>
        <th colSpan={4}>DUE</th>
        <td colSpan={2} style={{ width: '5rem' }}>
          <span
            style={{
              fontSize: '2rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            ⨂
          </span>
        </td>
        <th style={{ textAlign: 'center' }} colSpan={2}>
          DONE
        </th>
        <th style={{ background: '#51cf66' }}></th>
        <th colSpan={2} style={{ textAlign: 'center' }}>
          Reschedule
        </th>
        <th style={{ background: '#343a40' }}></th>
        <th style={{ textAlign: 'center' }} colSpan={2}>
          Annual Basis
        </th>
        <td colSpan={4}></td>
      </tr>
      <tr>
        <th colSpan={2}>YEAR:</th>
        <th colSpan={15}>{getYearRange(moduleData.date_range)}</th>
      </tr>

      {[
        'Sr. No.',
        'Machine No.',
        'M/C Name',
        'Location',
        'Status',
        'APR',
        'MAY',
        'JUN',
        'JUL',
        'AUG',
        'SEP',
        'OCT',
        'NOV',
        'DEC',
        'JAN',
        'FEB',
        'MAR',
        'Remarks',
      ].map((el, index) => (
        <th
          key={`${index}_head`}
          align="center"
          style={{
            textAlign: 'center',
            ...style1,
            minWidth: `${
              (el === 'INSTRUMENTS/GAUGE' && '250px') ||
              (el === 'S. No.' && '50px') ||
              style1.minWidth
            }`,
          }}
        >
          {el}
        </th>
      ))}

      {/* {[
        'APR',
        'MAY',
        'JUN',
        'JUL',
        'AUG',
        'SEP',
        'OCT',
        'NOV',
        'DEC',
        'JAN',
        'FEB',
        'MAR',
      ].map((el, index) => (
        <th
          key={`${index}_headcol`}
          align="center"
          style={{ textAlign: 'center', ...style2 }}
        >
          {el}-{index > 8 ? +date + 1 : date}
        </th>
      ))}
      <th style={{ textAlign: 'center', ...style1 }}>Average</th>
      <th style={{ textAlign: 'center', ...style1 }}>Remarks</th> */}
    </thead>
  );
};

export default THead;
